import { Divider } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import { DateWithTooltip } from "components/DateWithTooltip";
import ProgressIndicatorContainer from "components/ProgressIndicatorContainer";
import PropTypes from "prop-types";
import React from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { styled } from "@mui/material/styles";
import { AlertTimeSeriesChart } from "components/AlertsManagement/Chart";
import { convertActionToString } from "components/AlertsManagement/Archived/convertActionToString";
import { Link } from "react-router-dom";
import { caseIdToDisplayId } from "core/utils/str";
import buildUserName from "core/utils/build_user_name";

export function AlertOccurenceInfo({ alertOccurrence, alertsLoading }) {
  return (
    <ProgressIndicatorContainer loading={alertsLoading && !alertOccurrence}>
      {alertOccurrence ? (
        <>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item xs={6}>
                <Typography variant="h4">
                  {alertOccurrence.rule_name ?? ""}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Typography variant="h6">
            {alertOccurrence.machine_name}, {alertOccurrence.severity_type_name}
            , {alertOccurrence.component_name}
          </Typography>
          <Typography>
            <DateWithTooltip date={alertOccurrence.alert_date} />
          </Typography>

          <PerfectScrollbar>
            <ChartSection>
              <AlertTimeSeriesChart
                tagId={alertOccurrence.tag_id}
                tagName={alertOccurrence.tag_name}
                tagUnit={alertOccurrence.tag_unit}
                machineId={alertOccurrence.machine_id}
                severityTypeId={alertOccurrence.severity_type_id}
                ruleId={alertOccurrence.rule_id}
                ruleName={alertOccurrence.rule_name}
              />
            </ChartSection>
            <Divider />
            <ActionSection
              caseId={alertOccurrence?.case_id}
              action={alertOccurrence.action}
              actionedDate={alertOccurrence.actioned_date}
              actionedBy={buildUserName({
                first_name: alertOccurrence.actioned_by_first_name,
                last_name: alertOccurrence.actioned_by_last_name
              })}
            />
            <Divider />
            <InnerSection>
              <Typography variant="h5">Notes / Recommendations</Typography>
              <Typography variant="body1">
                {alertOccurrence.recommendation || "No notes/recommendations"}
              </Typography>
            </InnerSection>
          </PerfectScrollbar>
        </>
      ) : (
        "No alert occurrence available"
      )}
    </ProgressIndicatorContainer>
  );
}

AlertOccurenceInfo.propTypes = {
  alertOccurrence: PropTypes.object,
  alertsLoading: PropTypes.bool
};

const InnerSection = styled("div")`
  padding: ${props => props.theme.spacing(2)} 0;
  flex-grow: 1;
`;

const ChartSection = styled(InnerSection)`
  height: 395px;
`;

const ActionSection = ({ action, actionedDate, actionedBy, caseId }) => {
  let caseDisplayId = null;
  if (caseId) {
    caseDisplayId = caseIdToDisplayId(caseId);
  }

  return (
    <InnerSection>
      <Typography variant="h5">Action details</Typography>
      <Typography>
        <b>Action</b>: {convertActionToString(action)}
        {caseId && (
          <>
            <span>:&nbsp;</span>
            <Link to={`/pages/case-management/${caseId}`}>{caseDisplayId}</Link>
          </>
        )}
      </Typography>
      <Typography>
        <b>Actioned on</b>: <DateWithTooltip date={actionedDate} showTime />
      </Typography>
      <Typography>
        <b>Actioned by</b>: {actionedBy}
      </Typography>
    </InnerSection>
  );
};

ActionSection.propTypes = {
  action: PropTypes.string,
  caseId: PropTypes.number,
  actionedDate: PropTypes.string,
  actionedBy: PropTypes.string
};
